import { type AvailableProduct, type ProviderResults } from '../../types';
import { isComplete, isError } from '../providers/as-data-provider';
import companyHub from './company-hub';

import { getProductSiteUrl, type SwitcherItemType } from './links';
import { createCollector } from './create-collector';
import { SwitcherLoadError, SwitcherLoadErrorReason } from './errors/switcher-load-error';

function collectCurrentSiteAvailableProducts(
	currentCloudId: string,
	productConfiguration?: ProviderResults['productConfiguration'],
	availableProducts?: ProviderResults['availableProducts'],
): AvailableProduct[] | undefined {
	if (availableProducts && productConfiguration) {
		if (isError(productConfiguration)) {
			throw new SwitcherLoadError(
				SwitcherLoadErrorReason.PRODUCT_CONFIGURATION,
				productConfiguration.error,
			);
		}

		if (isError(availableProducts)) {
			throw new SwitcherLoadError(
				SwitcherLoadErrorReason.AVAILABLE_PRODUCTS,
				availableProducts.error,
			);
		}

		if (
			Boolean(currentCloudId) &&
			isComplete(productConfiguration) &&
			isComplete(availableProducts)
		) {
			const currentSite = availableProducts.data.sites.find(
				(site) => site.cloudId?.toLowerCase() === currentCloudId.toLowerCase(),
			);
			return currentSite?.availableProducts.map((product) => ({
				...product,
				url: getProductSiteUrl(productConfiguration.data.products, product, currentSite.url),
			}));
		}
		return;
	}
	return;
}

export const buildCompanyHub = (
	availableProducts: ProviderResults['availableProducts'],
	productConfiguration: ProviderResults['productConfiguration'],
	cloudId?: string | null,
): SwitcherItemType | undefined => {
	const collect = createCollector();

	if (availableProducts.data?.switcherTeam25ExperimentCohort === 'test' && cloudId) {
		const currentSiteAvailableProducts = collect(
			collectCurrentSiteAvailableProducts(cloudId, productConfiguration, availableProducts),
			[],
		);

		const confluenceWithCompanyHubPublished = currentSiteAvailableProducts.find(
			(product) => product.isCompanyHubPublishedAndPremium,
		);

		if (confluenceWithCompanyHubPublished) {
			return companyHub(
				`${confluenceWithCompanyHubPublished.url}/company-hub`,
				confluenceWithCompanyHubPublished.companyHubName,
			);
		}
	}

	return;
};
